export class Fee {
    FeeCode: string;
    FeeAmount: string;
    FeeDescription?: string;
    FeeVersion: string;
}
